export class KalkulatorService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
	}
	init() {
		return this.$http.get('/api/kalkulator/init').then(response => response.data);
	}
	megtakaritasKalkulacio(data) {
		return this.$http.post('/api/kalkulator/megtakaritas', data).then(response => response.data);
	}
	jaradekKalkulacio(data) {
		return this.$http.post('/api/kalkulator/jaradek', data).then(response => response.data);
	}
	sendVhk(data) {
		let captchaValue = data.captchaValue;
		delete data.captchaValue;
		return this.$http.post('/api/visszahivas/kalkulator', data, {
			headers: {
				'captcha': captchaValue
			}
		}).then(response => response.data);
	}
}



// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator.service.js